import { render, staticRenderFns } from "./GroupWorkspacePanel.vue?vue&type=template&id=6e4a5ff0"
import script from "./GroupWorkspacePanel.vue?vue&type=script&lang=js"
export * from "./GroupWorkspacePanel.vue?vue&type=script&lang=js"
import style0 from "./GroupWorkspacePanel.vue?vue&type=style&index=0&id=6e4a5ff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports